export default function atnlConsolePrint(){
	const colors = [
		"#FFB3BA", "#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF",
		"#C1C8E4", "#D4A5A5", "#FFB7C5", "#C8C8A9", "#FFD1DC",
		"#FF9AA2", "#FFDAC1", "#E2F0CB", "#B5EAD7", "#C7CEEA",
		"#FFCCF9", "#F6A6FF", "#D2A4FF", "#B5B9FF", "#A2E1DB",
		"#A6E3E9", "#BDE0FE", "#CAF0F8", "#E9C46A", "#F4A261"
	];
	const color = colors[Math.floor(Math.random()*colors.length)];
	const logo =
	`
                @@@@@@@@@@@@@@@@@@@@@@ ®
              @@@@@@@@@@@@@@@@@@@@@@@@
           @@@@@@@@@@@@@@@@@@@@@@@@@@@
        @@@@@              @@@@@@@@@@@
      @@@@@             @@@@@@@@@@@@@@
    @@@@@@@           @@@@@ @@@@@@@@@@
   @@@@@@@@        @@@@@@   @@@@@@@@@@
  @@@@@@@@@@@    @@@@@      @@@@@@@@@@
   @@@@@@@@@@@@@@@@@        @@@@@@@@@@
    @@@@@@@@@@@@@           @@@@@@@@@@
      @@@@@@@@@             @@@@@@@@@@
      @@@@@@                @@@@@@@@@@
    @@@@@@                  @@@@@@@@@@
 @@@@@@@@@@@                @@@@@@@@@@
 @@@@@@@@@@@@@             @@@@@@@@@@@
   @@@@@@@@@@@@@@        @@@@@@@@@@@@@@
     @@@@@@@@@@@@@@   @@@@@@@@@@@@@@@@@@
        @@@@@@@@@@@@@@@@@    @@@@@@@@@@@@
          @@@@@@@@@@@@        @@@@@@@@@@
             @@@@@@            @@@@@@@
               @@                @@ atonal.studio
`;
	console.log(`%c${logo}`, `font-family: monospace; line-height: 1.4; font-size: 12px; color: ${color}`);
}
